"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorMessageCustomed = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const StyledSpan = styled_components_1.default.span `
    display: flex;
    justify-content: left;
    align-items: left;
    background-color: ${({ theme, customStyle }) => { var _a, _b; return (_b = (_a = customStyle === null || customStyle === void 0 ? void 0 : customStyle.color) === null || _a === void 0 ? void 0 : _a.primary) !== null && _b !== void 0 ? _b : theme.invalidRed; }};
    color: ${({ theme, customStyle }) => { var _a, _b; return (_b = (_a = customStyle === null || customStyle === void 0 ? void 0 : customStyle.color) === null || _a === void 0 ? void 0 : _a.white) !== null && _b !== void 0 ? _b : theme.white; }};
    padding: 5px;
    border-radius: 5px;
    font-family: ${({ theme, customStyle }) => { var _a, _b; return (_b = (_a = customStyle === null || customStyle === void 0 ? void 0 : customStyle.font) === null || _a === void 0 ? void 0 : _a.fontFamily) !== null && _b !== void 0 ? _b : theme.fontFamily; }};
    font-size: 14px;
    margin: 5px 0 0 0;
    width: 100%;
`;
const ErrorMessageCustomed = ({ message, customStyle }) => {
    return (react_1.default.createElement(StyledSpan, { customStyle: customStyle }, message));
};
exports.ErrorMessageCustomed = ErrorMessageCustomed;
